/**
 * LicenseGuard - route-level guard. v2026.06.96.
 * Supporte requires={'license'|'pro'|'business'}.
 */
import { ReactNode } from 'react';
import { useLicense } from './LicenseGate';
import { LicenseRequiredGate } from '../components/LicenseRequiredGate';

type RequiredPlan = 'license' | 'pro' | 'business';

interface Props {
  children:        ReactNode;
  featureNameKey?: string;
  requires?:       RequiredPlan;
}

const PRO_OR_HIGHER      = new Set(['pro', 'business', 'enterprise']);
const BUSINESS_OR_HIGHER = new Set(['business', 'enterprise']);

export function LicenseGuard({ children, featureNameKey, requires = 'license' }: Props) {
  const { isTrial, loading, status, hasLicense } = useLicense();

  if (loading) return null;

  const currentPlan = (status?.plan ?? '').toLowerCase();
  const isValid     = Boolean(hasLicense && status?.valid);

  let allowed = false;
  if (requires === 'license') {
    allowed = !isTrial;
  } else if (requires === 'pro') {
    allowed = isValid && PRO_OR_HIGHER.has(currentPlan);
  } else if (requires === 'business') {
    allowed = isValid && BUSINESS_OR_HIGHER.has(currentPlan);
  }

  if (allowed) return <>{children}</>;

  return (
    <LicenseRequiredGate
      featureNameKey={featureNameKey}
      requires={requires}
      currentPlan={currentPlan}
    >
      {null}
    </LicenseRequiredGate>
  );
}
